import React from 'react';
import { FadeIn } from './FadeIn';
export function OriginStory() {
  return <section className="py-14 px-6 bg-[#0a0a0a]" data-id="element-206">
      <div className="max-w-3xl mx-auto" data-id="element-207">
        <FadeIn data-id="element-208">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-209">
            Todo comenzó con una{' '}
            <span className="text-brand-rose italic" data-id="element-210">pregunta simple</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-211">
          <div className="prose prose-invert prose-lg mx-auto text-brand-lightGray" data-id="element-212">
            <blockquote className="text-2xl font-serif text-brand-cream border-l-4 border-brand-rose pl-6 my-6 italic" data-id="element-213">
              "¿Por qué algunas mujeres hacen que los hombres se obsesionen… y
              otras no?"
            </blockquote>

            <p className="mb-4" data-id="element-214">
              Después de analizar cientos de conversaciones reales… patrones
              repetidos aparecieron.
            </p>

            <p className="mb-4" data-id="element-215">
              No era belleza. No era suerte. No era casualidad.
              <strong className="text-brand-cream font-medium" data-id="element-216">
                {' '}
                Era psicología aplicada en la comunicación.
              </strong>
            </p>

            <div className="bg-brand-gray/30 p-6 rounded-2xl border border-white/5 mt-6" data-id="element-217">
              <p className="text-brand-cream mb-3 font-medium" data-id="element-218">
                Se identificaron:
              </p>
              <ul className="space-y-2 list-disc list-inside marker:text-brand-rose" data-id="element-219">
                <li data-id="element-220">Frases que generan respuesta inmediata</li>
                <li data-id="element-221">Patrones que hacen que él invierta</li>
                <li data-id="element-222">Errores que destruyen el interés</li>
              </ul>
              <p className="mt-4 text-brand-rose font-semibold" data-id="element-223">
                Y así nació este sistema.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}